<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal-container" style="max-width: 65vw; width: 65vw; max-height: 80vh; overflow-y: auto; padding: 0;">
                <div class="modal-header" style="background-color: #274188; padding: 15px 25px !important; padding-bottom: 15px !important; border-top-left-radius: 2px; border-top-right-radius: 2px; display: flex; justify-content: space-between; align-items: center;">
                    <h2 style="margin: 0; color: white;">Daily Doses</h2>
                    <button @click.stop="closeMhrModal()" class="red-close-button" style="margin: 0;">
                        <i class="pi pi-times" style="padding: 0;"></i>
                    </button>
                </div>
            <div v-if="loadingDailyDoses" style="padding: 20px; text-align: center;">
                <h4>Loading Daily Doses...</h4>
                <i class="pi pi-spin pi-spinner" style="font-size: 2rem !important;margin-top: 1em;"></i>
            </div>
            <div v-else-if="dailyDoses && dailyDoses.length" style="padding: 20px;">
                <table style="border-collapse: collapse; width: 100%;">
                    <thead>
                        <tr style="background-color: #f3f4f4;">
                            <th style="padding: 10px; text-align: left; border-bottom: 1px solid #ddd;">Medication</th>
                            <th style="padding: 10px; text-align: left; border-bottom: 1px solid #ddd;">Time</th>
                            <th style="padding: 10px; text-align: left; border-bottom: 1px solid #ddd;">Dose</th>
                            <th style="padding: 10px; text-align: left; border-bottom: 1px solid #ddd;">Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(drug, i) in dailyDoses" :key="i" style="border-bottom: 1px solid #ddd;">
                            <td style="padding: 10px; text-align: left;">{{ drug.alias?.name }}</td>
                            <td style="padding: 10px; text-align: left;">{{ drug.custom_fields?.time }}</td>
                            <td style="padding: 10px; text-align: left;">{{ drug.custom_fields?.dose }}</td>
                            <td style="padding: 10px; text-align: left;">
                                <span style="margin-right: 5px" v-if="drug.prescription && drug.prescription.deleted_at" class="s8-tag">Ceased at {{ drug.prescription.deleted_at?.slice(0,-7) || drug.prescription.deleted_at }}</span>
                                <span style="margin-right: 5px" v-else-if="drug.prescription && isMedicationExpired(drug.prescription)" class="orange-tag">Expired at {{ drug.prescription.stop_date?.slice(0,-7) || drug.prescription.stop_date }}</span>
                                <span style="margin-right: 5px" v-else-if="drug.prescription && !isMedicationExpired(drug.prescription)" class="green-tag">Active</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div v-else style="padding: 20px; text-align: center;">
                <h3>No Daily Doses available for this resident.</h3>
            </div>
        </div>
        </div>
    </div>
</template>

<script>
import { isBeforeToday } from '@/services/dates';

export default {
    props: ['patient', 'dailyDoses', 'loadingDailyDoses', 'isErxChartExpired'],
    methods: {
        closeMhrModal() {
            this.$emit('close');
        },
        isMedicationExpired(item) {
            if (item.script_status === 'ceased' || item.script_status === 'cancelled') {
                return false;
            }
            if (item.deleted_at) {
                return false;
            }
            if (this.isErxChartExpired) {
                return true;
            }
            if (item.script_status === 'expired') {
                return true;
            }
            if (item.stop_date) {
                return isBeforeToday(item.stop_date);
            }
            return false;
        }
    }
}
</script>

<style scoped>
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
}

.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
}

.modal-container {
    margin: 0px auto;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    font-family: Helvetica, Arial, sans-serif;
}
</style>
